import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');

export const getters = {
    getTypeActorFields() {
        return {
            model: 'type_actor',
            label: 'Types Actor',
            fields: [
                { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
                { key: 'id_license', label: 'id_license', type: 'number', sortable: true, required: true },
                { key: 'status', label: 'status', type: 'boolean', sortable: true, required: true },
            ]
        }
    },
}

export const actions = {
    async fetchActorTypes(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/masters/actor_types/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchOptionsActorTypes(context, query = '') {
        return axios
            .options(`${serverUrl}/api/v1/masters/actor_types/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async createActorTypes(context, payload) {
        return axios
            .post(`${serverUrl}/api/v1/masters/actor_types/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async updateActorTypes(context, payload) {
        return axios
            .put(`${serverUrl}/api/v1/masters/actor_types/${payload.id}/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async deleteActorTypes(context, id) {
        return axios
            .delete(`${serverUrl}/api/v1/masters/actor_types/${id}/`)
            .then((response) => {
                return response.data;
            })
    }
}